angular.module('webremote.layout').controller('webremote.modules.layout.activeMarker.controller',
  function ($scope, $location) {
    $scope.isActive = function (viewLocation) {
      return viewLocation === '/' + $location.path().split('/')[1]
    }
  })
